import React, {useState, useRef, useEffect} from 'react';
import dataTableSettings from '../../TrialUI/dataTableSettings';
import DataTable from '../../DataTable';
import axios from 'axios';
import axiosConfig from '../../../config/axios.config';
import { UserContext } from '../../../Context/UserContext';
import { InstanceContext } from '../../../InstanceContext';
import trialSettings from './settings';
import { trackError } from '../../../utils/activityTracker'
import TopToolbar from "../../DataTable/TopToolbar";
import {DataTableContextProvider} from "../../DataTable/Utils/DataTableContext";

const UserManagement = (props) => {
  const { user, userAction } = React.useContext(UserContext);
  const { contextInstance } = React.useContext(InstanceContext);
  const [userData, setUserData] = useState([]);
  const [customMemo, setCustomMemo] = React.useState(0)
  const tabSettings = trialSettings.tabs.users;
  const trialInstance = contextInstance || user.instance;
  let mounted = useRef(false);
  const tableRef = useRef();
  const [maxWidth, setMaxWidth] = React.useState(null);
  const [selected, setSelected] = React.useState('By Session');

  const [headers, setHeaders] = React.useState(['fn', 'ln', 'roleEmr', 'referralOpen', 'submissionOpen', 'launchDate', 'submissionDate'])

  if (tableRef.current && maxWidth === null) {
    const tableBounds = tableRef.current.getBoundingClientRect();
    const tableWidth = tableBounds.right - tableBounds.left;
    const value = Math.floor(tableWidth);
    setMaxWidth(value);
  }

  const getUserDetails = (query, isCondition) => {
    mounted.current = true;
    setUserData([]);
    // removed 'axiosConfig.auth' as token is updated on login
    let url = `${axiosConfig.apiUrl}/rt/console/emrActivity/${trialInstance}/${user.email}`;
    if(query) url+=`?tag=${query}`;
    else if(selected) url+=`?tag=${selected}`
    axios.get(url)
      .then(response => {
        setUserData(response.data);
        setCustomMemo(customMemo + 1)
      }).catch(error => {
      console.log('error', error);
      trackError({ error: error, history: props.history })
      if (error.response.status === 403) {
        userAction({type: 'logout'})
      }
    });
  }

  if (!mounted.current) getUserDetails();

  const paramOptions = {
    all: "By Session",
    provider: "By Provider",
    condition: "By Condition",
  }

  const handleAction = (data) => {
    let tag = data.replace('%20', ' ');
    setSelected(tag);
    if(tag === 'By Provider') setHeaders([
      'fn',
      'ln',
      'roleEmr',
      'sessionCount',
      'referralCount',
      'submissionCount',
      'latestDate'
    ])
    else if(tag === 'By Condition') setHeaders(['condition', 'sessionCount', 'referralCount', 'submissionCount'])
    else if(tag === 'By Session') setHeaders(['fn', 'ln', 'roleEmr', 'referralOpen', 'submissionOpen', 'launchDate', 'submissionDate'])
    getUserDetails(data)
  }

  // mount/unmount resize event listener
  const resizeResponse = () => setMaxWidth(null);
  useEffect(() => {
    window.addEventListener('resize', resizeResponse);
    return(() => window.removeEventListener('resize', resizeResponse))
  }, [])

  return <div ref={tableRef}>
    <DataTableContextProvider {...props} dataTableID={props.tableID || 'dt_instance_0'}>
      <TopToolbar
        paramOptions={paramOptions}
        handleAction={handleAction}
        activity
        activeUserParam={selected}
        width={maxWidth ? maxWidth - 15 + 'px' : '100%'}
        tableElement={tableRef}
      />
      <DataTable
        {...props}
        settings={dataTableSettings}
        // headerSettings={dataTableSettings}
        history={props.history}
        location={props.location}
        tabSettings={tabSettings}
        noSearch
        headers={headers}
        data={userData}
        dropdown={selected !== 'By Condition' ? tabSettings.dropdown : null}
        userDetails={getUserDetails}
        options={{
          customTopOffset: 45,
          offsetWidth: 175
        }}
        memo={customMemo}
      />
    </DataTableContextProvider>
  </div>
}

export default UserManagement;
